import React from 'react';
import PropTypes from 'prop-types';
import styled, {css} from 'styled-components';

import {Form, Select} from 'semantic-ui-react';

// import translate from '../utils/translate';
// import dictionary from './dictionary.json';
// const t = translate(dictionary);

const StyledDropdown = styled(Form.Field)`
  ${({$fitParentWidth}) => $fitParentWidth && css`
    min-height: 2.7142857142857144rem;

    .ui.dropdown {
      position: absolute;
      width: 100%;
    }
  `}
  .ui.dropdown > .search.icon,
  .ui.dropdown > .delete.icon,
  .ui.dropdown > .dropdown.icon {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
    top: 0.5rem;
    right: 0.5rem;
  }

  .ui.dropdown > .clear.dropdown.icon {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .ui.dropdown > .clear.icon:before {
    position: absolute;
    top: 50%;
    //left: 50%;
    transform: translate(-50%, -50%);
  }

  .ui.dropdown > .clear.dropdown.icon {
    right: 1.14285714rem;
  }

  .ui.dropdown .menu .item {
    display: flex;
    flex-direction: row-reverse;
    padding: 0.7142857142857143rem 0.8571428571428571rem !important;
    justify-content: flex-end;
    align-items: center;
  }

  .ui.dropdown .menu .bold.item {
    font-weight: 900;
  }


  &:not(.description-for-valid) .ui.dropdown .description + .text {
    color: #aaa;
  }

  .ui.dropdown > .text {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    display: inline-block;
    vertical-align: top;
  }
  
  .ui.dropdown > .text > .description,
  .ui.dropdown .menu > .item > .description {
    margin-left: auto;
    font-size: 0.6428571428571429rem;
    line-height: 0.8571428571428571rem;
    color: #475566;
    white-space: nowrap;
  }
`;

const propTypes = {
    name: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    error: PropTypes.bool,
    label: PropTypes.string,
    value: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
        PropTypes.arrayOf(
            PropTypes.oneOfType([
                PropTypes.string,
                PropTypes.number,
            ])
        )
    ]),
    selectOnBlur: PropTypes.bool,
    tableCell: PropTypes.bool,
    options: PropTypes.arrayOf(
        PropTypes.shape({
            text: PropTypes.string.isRequired,
            value: PropTypes.oneOfType([
                PropTypes.string,
                PropTypes.number
            ]),
        })
    ),
    clearable: PropTypes.bool
};


const Dropdown = ({
                      selectOnBlur = false,
                      tableCell = false,
                      options = [],
                      compact = false,
                      className = '',
                      multiple = false,
                      fitParentWidth = false,
                      style = {},
                      ...restProps
                  }) =>
    (
        <StyledDropdown
            className={`${compact ? 'ultra-compact' : ''} ${tableCell ? 'small hidden-border' : ''} ${className || ''}`.trim()}
            $fitParentWidth={fitParentWidth && !multiple}
            search
            fluid
            control={Select}
            multiple={multiple}
            noResultsMessage={'Не найдено'}
            selectOnBlur={selectOnBlur}
            options={options}
            style={style}
            {...restProps}
        />
    );


Dropdown.propTypes = propTypes;
export default Dropdown;



// WEBPACK FOOTER //
// ./App/components/Dropdown.jsx